














































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class GuidedHeaderLetter extends Vue {
  @Prop(String) readonly title!: string;
  @Prop(String) readonly letter!: string | null;
  @Prop(String) readonly infoDetailLetter!: string | null;
  @Prop(Boolean) readonly isSelected!: boolean;
  @Prop(Boolean) readonly breakdown!: boolean;

  infoDialog = false;
}
